<img [ngSrc]="'404' | asset: 'not-found'" width="444" height="301" alt="404 Error Image" />
<div class="flex flex-col gap-15px text-center text-dark text-medium-medium">
    <span class="text-secondary-text-color" i18n="@@not-found-title">That’s an error</span>
    <span class="text-h5-semi-bold" i18n="@@not-found-sub-title">Ooops. Page not found :(</span>
    <span i18n="@@not-found-description"
        >Sorry, the page you’re looking for doesn’t exist. if you think something is broken,
        <a class="underline text-primary-color cursor-pointer" routerLink="/contact-us">report a problem!</a></span
    >
</div>
<a routerLink="/" class="button-black-outline mob:w-full" i18n="@@button-go-home">Go Home</a>
